import cssString from "../styles/_minified/index.css"
import modalString from "../styles/_minified/modal.css"
import { LayoutsState, LayoutState } from "../types/types"
import * as testData from "../../test.json"
import { createChevronLeftIcon, createCloseIcon, createEyeIcon, createFullscreenIcon, createLayout, createModal, createTrashIcon } from "../utils/createElemets"
import { BASE_API_URL } from "../layouts-upload-modal"

window.layoutsState = {}
window.layoutsUploadModal = null
window.layoutsViewerModal = null

export class LayoutsUploadModal extends HTMLElement {
    #currentStep: number

    #modal: HTMLDivElement
    #uploadView: HTMLDivElement
    #uploadSections: HTMLDivElement
    #layoutsView: HTMLDivElement
    #layoutsSections: HTMLDivElement

    #footerStepOne: HTMLDivElement
    #footerStepOneSubmitBtn: HTMLButtonElement
    #footerStepOneLabel: HTMLLabelElement

    #footerStepTwo: HTMLDivElement
    #footerStepTwoSubmitBtn: HTMLButtonElement
    #footerStepTwoLabel: HTMLLabelElement

    get step() {
        return this.#currentStep
    }

    set step(number) {
        this.#currentStep = number
        if (number === 1) {
            this.#modal.replaceChild(this.#uploadView, this.#layoutsView)
            this.#modal.replaceChild(this.#footerStepOne, this.#footerStepTwo)
            this.#updateUploadSections()
        }
        else if (number === 2) {
            this.#modal.replaceChild(this.#layoutsView, this.#uploadView)
            this.#modal.replaceChild(this.#footerStepTwo, this.#footerStepOne)
        }
    }

    #updateUploadSections() {
        if (!this.#uploadSections) return
        this.#uploadSections.innerHTML = ''
        partsData.forEach(partData => {
            const section = document.createElement('section')
            section.classList.add('uploads')

            const title = document.createElement('span')
            title.classList.add('title')
            title.textContent = partData.name

            const uploadZones = document.createElement('div')
            uploadZones.classList.add('upload-zones')

            const sides = partData.countPrintingSides ?? 1
            for (let i = 0; i < sides; i++) {
                const uploadZone = document.createElement('upload-zone')
                uploadZone.setAttribute("part-data", partData.id)
                uploadZone.setAttribute("index", `${i}`)
                uploadZones.append(uploadZone)
            }

            section.append(title, uploadZones)
            this.#uploadSections.append(section)
        })
    }

    #proxyHandler = (component: this) => ({
        get(target: LayoutsState, key: string) {
            return target[key]
        },
        set(target: LayoutsState, key: string, value: (LayoutState | null)[]) {
            target[key] = value

            if (component.step === 1)
                component.#updateUploadSections()

            const layouts = Object.values(target).flat()
            if (!layouts.includes(null)) {
                const hasErrors = layouts.map(layout => layout?.errors).includes(true)
                if (hasErrors) {
                    component.#footerStepOne.append(component.#footerStepOneLabel)
                } else {
                    if (Array.from(component.#footerStepOne.children).includes(component.#footerStepOneLabel))
                        component.#footerStepOne.removeChild(component.#footerStepOneLabel)
                    component.#footerStepOneSubmitBtn.disabled = false
                }
            } else {
                component.#footerStepOneSubmitBtn.disabled = true
                if (Array.from(component.#footerStepOne.children).includes(component.#footerStepOneLabel))
                    component.#footerStepOne.removeChild(component.#footerStepOneLabel)
            }

            return true
        }
    })

    constructor() {
        super()

        this.#currentStep = 1

        layoutsState = new Proxy(layoutsState, this.#proxyHandler(this))

        // Modal ----------
        this.#modal = document.createElement('div')
        this.#modal.classList.add('layouts-upload-modal')
        const modalCloseBtn = document.createElement('button')
        modalCloseBtn.append(createCloseIcon('var(--gray-500, #A0AEC0)'))
        modalCloseBtn.onclick = () => {
            this.remove()
        }
        this.#modal.append(modalCloseBtn)

        // Footer ----------
        this.#footerStepOne = document.createElement('div')

        this.#footerStepOneSubmitBtn = document.createElement('button')
        this.#footerStepOneSubmitBtn.type = 'button'
        this.#footerStepOneSubmitBtn.textContent = 'К согласованию макета'
        this.#footerStepOneSubmitBtn.disabled = true
        this.#footerStepOneSubmitBtn.onclick = () => {
            if (this.#currentStep === 1)
                this.step = 2
        }

        this.#footerStepOneLabel = document.createElement('label')
        this.#footerStepOneLabel.textContent = 'Да, я ознакомился с замечаниями к макетам'
        const inputOne = document.createElement('input')
        inputOne.type = 'checkbox'
        inputOne.onchange = e => {
            if ((e.currentTarget as HTMLInputElement).checked)
                this.#footerStepOneSubmitBtn.disabled = false
            else
                this.#footerStepOneSubmitBtn.disabled = true
        }
        this.#footerStepOneLabel.prepend(inputOne)
        this.#footerStepOne.append(this.#footerStepOneSubmitBtn)

        this.#footerStepTwo = document.createElement('div')

        this.#footerStepTwoSubmitBtn = document.createElement('button')
        this.#footerStepTwoSubmitBtn.type = 'button'
        this.#footerStepTwoSubmitBtn.textContent = 'Согласовываю'
        this.#footerStepTwoSubmitBtn.disabled = true
        this.#footerStepTwoSubmitBtn.onclick = () => {
            if (this.#currentStep === 1)
                this.step = 2
        }

        this.#footerStepTwoLabel = document.createElement('label')
        this.#footerStepTwoLabel.textContent = 'Я ознакомился с требованиями по подготовке макета и подтверждаю соответствие макета требованиям. Макет не содержит орфографические ошибки и запрещенный контент.'
        const inputTwo = document.createElement('input')
        inputTwo.type = 'checkbox'
        inputTwo.onchange = e => {
            if ((e.currentTarget as HTMLInputElement).checked)
                this.#footerStepTwoSubmitBtn.disabled = false
            else
                this.#footerStepTwoSubmitBtn.disabled = true
        }
        this.#footerStepTwoLabel.prepend(inputTwo)
        this.#footerStepTwo.append(this.#footerStepTwoSubmitBtn, this.#footerStepTwoLabel)

        partsData.forEach(partData => {
            layoutsState[partData.id] = new Array(partData.countPrintingSides ?? 1).fill(null) // ((testData as unknown) as LayoutsState)[partData.id] //
        })

        // Upload view ----------
        this.#uploadView = document.createElement('div')

        const h2 = document.createElement('h2')
        h2.textContent = 'Загрузка макетов'

        const sectionsContainer = document.createElement('div')
        this.#uploadSections = document.createElement('div')
        this.#uploadSections.classList.add('sections')
        this.#updateUploadSections()

        sectionsContainer.append(this.#uploadSections)
        this.#uploadView.append(h2, sectionsContainer)

        // Layouts view ----------
        this.#layoutsView = document.createElement('div')

        const backBtn = document.createElement('button')
        backBtn.textContent = 'Назад к загрузке'
        backBtn.prepend(createChevronLeftIcon())
        backBtn.onclick = () => {
            this.step = 1
        }

        const layoutsH2 = document.createElement('h2')
        layoutsH2.textContent = 'Согласование и просмотр макетов'

        const layoutsSectionsContainer = document.createElement('div')
        this.#layoutsSections = document.createElement('div')
        this.#layoutsSections.classList.add('sections')

        partsData.forEach((partData, index) => {
            const section = document.createElement('section')
            section.classList.add('layouts')

            const sectionTitle = document.createElement('span')
            sectionTitle.textContent = partData.name
            sectionTitle.classList.add('title')

            const sectionNumber = document.createElement('div')
            sectionNumber.classList.add('section-number')
            sectionNumber.textContent = `${index + 1}`
            sectionTitle.prepend(sectionNumber)

            const seeBtn = document.createElement('button')
            seeBtn.textContent = 'Смотреть подробнее'
            seeBtn.prepend(createEyeIcon())
            seeBtn.onclick = () => {
                const viewer = document.createElement('layouts-viewer')
                viewer.setAttribute('part-data-id', partData.id)
                viewer.setAttribute('index', `0`)
                document.body.append(viewer)
            }
            sectionTitle.append(seeBtn)

            const layouts = document.createElement('div')
            layouts.classList.add('layouts')

            layoutsState[partData.id].forEach((layoutState, index) => {
                if (!layoutState) return

                const layoutContainer = document.createElement('div')
                layoutContainer.classList.add('container')

                if (partData.countPrintingSides && partData.countPrintingSides > 1) {
                    const layoutSpan = document.createElement('span')
                    layoutSpan.textContent = index === 0 ? 'Лицевая' : 'Оборотная'
                    layoutContainer.append(layoutSpan)
                }

                const layout = createLayout(layoutState)
                layout.classList.add('list')
                const layoutRemoveBtn = document.createElement('button')

                layoutRemoveBtn.classList.add('remove')
                layoutRemoveBtn.append(createTrashIcon())
                layoutRemoveBtn.onclick = () => createModal({
                    title: 'Вы уверены что хотите удалить?',
                    subTitle: 'Вы вернетесь в режим проверки и загрузки макетов',
                    submitText: 'Да, удалить',
                    cancelText: 'Отменить',
                    action: () => {
                        let temp = layoutsState[partData.id].slice()
                        temp[index] = null
                        layoutsState[partData.id] = temp
                        this.step = 1
                    }
                }, this.shadowRoot)

                const layoutExpandBtn = document.createElement('button')
                layoutExpandBtn.classList.add('expand')
                layoutExpandBtn.append(createFullscreenIcon())
                layoutExpandBtn.onclick = () => {
                    const viewer = document.createElement('layouts-viewer')
                    viewer.setAttribute('part-data-id', partData.id)
                    viewer.setAttribute('index', `${index}`)
                    document.body.append(viewer)
                }

                layout.append(layoutRemoveBtn, layoutExpandBtn)

                layoutContainer.append(layout)
                layouts.append(layoutContainer)
            })

            section.append(sectionTitle, layouts)
            this.#layoutsSections.append(section)
        })

        layoutsSectionsContainer.append(this.#layoutsSections)
        this.#layoutsView.append(backBtn, layoutsH2, layoutsSectionsContainer)
    }

    connectedCallback() {
        if (!partsData) return

        const shadow = this.attachShadow({ mode: "open" })

        const sheet = new CSSStyleSheet()
        sheet.replaceSync(cssString + modalString)
        shadow.adoptedStyleSheets = [sheet]

        this.#modal.append(this.#uploadView, this.#footerStepOne)

        const backgroundTint = document.createElement('div')
        backgroundTint.classList.add('background-tint')
        shadow.append(this.#modal, backgroundTint)

        layoutsUploadModal = this
    }

    disconnectedCallback() {
        layoutsState = {}
        layoutsUploadModal = null
    }
}

customElements.define("layouts-upload-modal", LayoutsUploadModal)